export const formatMaterialLabel = (value: string | number | null | undefined, labelsById?: Record<number, string>) => {
  if (value === null || value === undefined || value === "") {
    return "N/A";
  }

  const id = typeof value === "string" ? Number(value) : value;
  if (Number.isNaN(id)) {
    return String(value);
  }

  const label = labelsById?.[id];
  return label ? `${label} [${id}]` : `[${id}]`;
};
